import type { Messages } from '../types'
import { adminCommerceMessages } from './admin-commerce'
import { trailerMessages } from './trailer'

export const en = {
  adminCommerce: adminCommerceMessages.en,
  trailerRefresh: trailerMessages.en,
  home: {
    quotaFull: 'Your subscription limit is reached. View membership options.',
    search: 'Search codes, actresses or titles',
    updates: 'Your subscription feed',
    updatesBody: 'New releases from the actresses you follow.',
    following: 'Actresses you follow',
    followingBody: 'Choose an actress to filter your feed.',
    discover: 'Take a look around',
    discoverBody: 'Explore a random selection from the catalogue.',
    shuffle: 'Shuffle',
    scrollPrevious: '{section}: scroll left',
    scrollNext: '{section}: scroll right',
    favorites: 'Saved for later',
    favoritesBody: 'Return to your favorites · ordered by release date',
    noSubscriptionsBody: 'Start with an actress you like. Follow her to see her releases here.',
    noUpdates: 'No releases from your subscriptions yet',
    noUpdatesBody: 'Your subscriptions are saved. Explore more releases while you wait.',
    noFavorites: 'Nothing saved yet. Tap the heart on a release to find it here next time.',
    noDiscovery: 'No releases to show yet. Check back later.',
  },
  admin7: {
    overviewHint: 'Local business data; external service health has not been checked',
    orders: 'Order review',
    config: 'Essential settings',
    content: 'Content maintenance',
    tasks: 'Task management',
    empty: 'No records',
    unknown: 'The request outcome is unknown. Check the original receipt. Do not submit again.',
    recover: 'Check original request',
    receipt: 'Confirmed receipt',
    newRequest: 'Start another operation',
    requestKey: 'Request key',
    role: 'Role',
    saveRole: 'Confirm role change',
    user: 'User',
    admin: 'Administrator',
    details: 'View details',
    save: 'Save',
    readBack: 'Read current state',
    loading: 'Loading…',
    email: 'Email',
    userId: 'User ID',
    id: 'Record ID',
    status: 'Status',
    source: 'Source',
    editActressSource: 'Correct actress crawl source',
    sourceIdentifier: 'JavBus source ID',
    currentSource: 'Current source ID',
    sourceHint:
      'Saving only corrects the source; it does not start a crawl. Refresh the actress profile separately to update it.',
    sourceFormat: '1–80 letters, digits, underscores or hyphens; must start with a letter or digit',
    sourceConflict: 'The source has changed. Read its current value before deciding whether to save.',
    reloadSource: 'Reload source',
    continueEditing: 'Continue editing',
    trailerMaintenance: 'Single-video trailer maintenance',
    trailerHint:
      'Only the selected video is affected. Existing media stays until the replacement succeeds. Check the task status after queuing; cancellation can be requested.',
    trailerMode: 'Source method',
    trailerAuto: 'Automatic discovery',
    trailerUrl: 'Public trailer URL',
    trailerFile: 'Local trailer file',
    trailerUrlHint:
      'Supports approved public trailer paths from DMM, MGS, Caribbean and others. Use a local file for other sources.',
    trailerFileHint: 'MP4 or MPEG-TS, up to 200 MiB. File contents are verified by the server.',
    uploading:
      'Uploading and waiting for a receipt. Keep this page open. After a timeout, only check the original task.',
    all: 'All',
    amount: 'Amount',
    created: 'Created',
    paid: 'Paid',
    expires: 'Expires',
    providerStatus: 'Provider status',
    merchantOrder: 'Merchant order ID',
    orderHint:
      'Read-only review of Payment orders. Excludes the separate Stars ledger and does not check with the provider or grant benefits. Currencies are shown separately.',
    revenue: 'CCPayment paid this month (USD)',
    revenueHint: 'UTC calendar month, USD only; excludes Stars, CDKeys and manual benefits',
    limit: 'Daily free registration limit',
    translationUrl: 'Translation service URL',
    model: 'Translation model',
    translationKey: 'Translation API key',
    appId: 'CCPayment App ID',
    paymentKey: 'CCPayment secret',
    fiat: 'Pricing fiat ID',
    coin: 'Pricing coin ID',
    configured: 'Configured; leave blank to keep',
    unset: 'Not configured',
    configHint:
      'Secret values are never returned. Leave blank to keep them. Saving returns redacted settings and does not verify external services.',
    recent: 'Crawl recent releases',
    actressCrawl: 'Crawl actress releases',
    videoRefresh: 'Refresh video',
    actressRefresh: 'Refresh actress profile',
    translateVideo: 'Translate one video',
    translateBatch: 'Translate a limited batch',
    kind: 'Operation',
    target: 'Target internal ID',
    pages: 'Maximum pages (1–10)',
    batchLimit: 'Batch limit (1–50)',
    enqueue: 'Confirm and queue',
    taskHint:
      'Queuing does not mean completion. Leaving this page does not cancel the task. Cancellation affects only the selected task.',
    active: 'Active tasks',
    history: 'Task history',
    cancelTask: 'Request cancellation',
    cancellation: 'Cancellation requested; waiting for the worker to finish',
    progress: 'Processed {processed} / {total} · Succeeded {success} · Failed {failed}',
    attempts: 'Attempt {attempts} / {max}',
    errorCode: 'Error code',
    taskId: 'Task ID',
    searchActress: 'Search local actresses',
    searchVideo: 'Search video codes or titles',
    searchBound: 'Enter at least 2 characters; up to 20 results',
    noContent: 'No matches found. Try another search.',
    selectedContent: 'Selected: {name}',
    search: 'Search',
    select: 'Select',
    unavailableStar: 'JavBus Star ID is missing',
    translationTitle: 'Edit translated title',
    videoId: 'Video internal ID',
    locale: 'Language',
    title: 'Title',
    translationSaved: 'Translated title saved',
    viewUser: 'Manage benefits',
    snapshot: 'Current benefits end date',
    manualHint:
      'By default, extend valid benefits or start from now if expired. Lifetime membership cannot be downgraded.',
    months: 'Months (1–120)',
    expectedEnd: 'Estimated end date (subject to the server receipt)',
    membershipConflict:
      'The benefits snapshot or request conflicts with the current state. Reload the user before continuing.',
    replaceLifetimeEffect: 'Replacement grants lifetime membership with no expiry date.',
    replaceFiniteEffect:
      'Replacement grants {months, plural, one {# month} other {# months}} from the effective time. Remaining time is discarded, which may shorten current benefits.',
    append: 'Extend benefits',
    replace: 'Replace benefits',
    mode: 'Benefits operation',
    reason: 'Operation note',
    replaceConfirm: 'Replace current benefits with the selected plan; this may shorten their validity',
  },
  brand: {
    name: 'JAV Tracker',
    admin: 'Administration',
  },
  nav: {
    today: 'Today',
    discover: 'Discover',
    library: 'Library',
    search: 'Search',
    me: 'Me',
    searchPlaceholder: 'Search codes, actresses, tags',
    account: 'Account menu',
    logout: 'Sign out',
    admin: 'Admin',
    language: 'Language',
    back: 'Back',
    backTo: 'Back to {target}',
    skipToContent: 'Skip to main content',
  },
  common: {
    retry: 'Retry',
    loading: 'Loading…',
    loadMore: 'Load more',
    loadError: 'Failed to load. Please retry.',
    networkError: 'Network connection failed',
    cancel: 'Cancel',
    apply: 'Apply',
    clearAll: 'Clear all',
    confirm: 'Confirm',
    close: 'Close',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Could not copy. Please select and copy manually.',
    videosCount: '{count, plural, one {# video} other {# videos}}',
    viewAll: 'View all',
    upgrade: 'Upgrade',
    end: 'You have reached the end',
    autoPaused: '{count, plural, one {# video} other {# videos}} loaded. Load more to continue browsing.',
    unknownOutcome: 'The request outcome is unknown. Checking with the server…',
    unknownPending: 'The request is not yet confirmed. Check its status before continuing.',
    verifyState: 'Check status',
    mockNotice: 'Mock data preview · all content is synthetic',
  },
  video: {
    retranslate: 'Translate again',
    retranslateHint:
      'Retranslate this title while keeping manual edits. The translation updates when complete.',
    new: 'New',
    magnets: '{count, plural, one {# magnet} other {# magnets}}',
    noMagnets: 'Awaiting magnets',
    trailer: 'Trailer',
    solo: 'Solo',
    favorite: 'Save',
    favorited: 'Saved',
    unfavorite: 'Remove from favorites',
    copyCode: 'Copy code',
    coverAlt: '{code} cover',
    coverFallback: 'Cover',
    releaseDate: 'Release date',
    duration: 'Duration',
    minutes: '{count} min',
    maker: 'Studio',
    series: 'Series',
    cast: 'Cast',
    tags: 'Tags',
    translated: 'Translation',
    original: 'Original Japanese',
    playTrailer: 'Play trailer',
    closeTrailer: 'Close trailer',
    trailerLabel: '{code} trailer',
    trailerError: 'The trailer could not load or play. Please try again.',
    trailerUnsupported:
      'This browser does not support the trailer format. Please use a browser with MediaSource support.',
    trailerPlayBlocked: 'Your browser paused autoplay. Use the playback controls below.',
    trailerHint: 'The trailer loads only when you press play.',
    noTrailer: 'No trailer available',
    copyBest: 'Copy best magnet',
    bestMeta: '{size} · {seeders, plural, one {# seeder} other {# seeders}} · {source}',
    bestRule: 'Automatically selected by seeders and file size',
    noMagnetYet: 'No magnets yet. Try refreshing.',
    allMagnets: 'All magnets',
    magnetCount: '{count, plural, one {# link} other {# links}}',
    refreshMagnets: 'Refresh magnets',
    refreshQuota: '{remaining}/{limit} left today',
    refreshing: 'Refreshing…',
    colName: 'Name',
    colSize: 'Size',
    colSeeders: 'Seeders',
    colSource: 'Source',
    best: 'Best',
    notFound: 'Video not found',
    notFoundBody: 'The code may be incorrect or not in the catalogue yet. Try an online search.',
  },
  actress: {
    recrawl: 'Crawl again',
    recrawlHint: 'Import recent films: up to 5 pages. The works list refreshes when the task ends.',
    subscribe: 'Follow',
    subscribed: 'Following',
    pending: 'Confirming…',
    unknown: 'Check again',
    unsubscribe: 'Unfollow',
    works: 'Releases',
    soloOnly: 'Solo',
    withCompilations: 'Include compilations',
    pushing: 'New releases will be sent to your Telegram',
    pushOff: 'Link Telegram to receive new-release notifications',
    debut: 'Debut',
    birthday: 'Birthday',
    height: 'Height',
    measurements: 'Measurements',
    videoTotal: 'Releases',
    limitReached: 'Free accounts can follow up to 5 actresses',
    notFound: 'Actress not found',
  },
  today: {
    title: 'Your release feed',
    summary:
      '{count, plural, one {# new release} other {# new releases}} since your last visit · Following {actresses, plural, one {# actress} other {# actresses}}',
    all: 'All',
    manage: 'Manage subscriptions',
    hasMagnets: 'Has magnets',
    hasTrailer: 'Has trailer',
    unfavorited: 'Not saved',
    sortRelease: 'By release date',
    today: 'Today',
    yesterday: 'Yesterday',
    groupCount: '{count, plural, one {# video} other {# videos}}',
    emptyNoSubs: 'You are not following anyone yet',
    emptyNoSubsBody: 'Follow actresses to see their new releases here, ordered by release date.',
    goDiscover: 'Discover actresses',
    emptyFiltered: 'No releases match these filters',
    emptyFilteredBody: 'Try different filters or clear them to see all updates.',
    quotaTitle: 'Free plan · Followed actresses',
    quotaFull: 'Limit reached. Membership offers unlimited follows and removes ads.',
    viewPlans: 'View membership plans',
  },
  discover: {
    title: 'Discover',
    videos: 'Videos',
    actresses: 'Actresses',
    tags: 'Tags',
    filter: 'Filters',
    filterCount: 'Filters · {count}',
    filterDraft: 'Draft · Not applied',
    applied: 'Applied:',
    onlyShow: 'Only show',
    solo: 'Solo releases',
    hasMagnets: 'Has magnets',
    hasTrailer: 'Has trailer',
    favorited: 'My favorites',
    releaseWindow: 'Release date',
    anyTime: 'Any time',
    days30: '30 days',
    thisYear: 'This year',
    tag: 'Tag',
    sortLabel: 'Sort videos',
    sortNewest: 'Release date · newest first',
    sortOldest: 'Release date · oldest first',
    sortCrawledNewest: 'Crawl date · newest first',
    sortCrawledOldest: 'Crawl date · oldest first',
    pageAt: 'Viewing page {page}',
    jump: 'Go',
    jumpLabel: 'Go to page',
    actressFilter: 'Name, Japanese name or romanization',
    all: 'All',
    subscribedOnly: 'Following',
    unsubscribedOnly: 'Not following',
    hotTags: 'Popular tags',
    hotTagsHint: 'By total favorites across the site',
    searchTags: 'Search all tags',
    expand: 'Show {count} more',
    collapse: 'Show less',
    tagFilterActive: 'Tag: {name}',
  },
  tagCategory: {
    QUALITY_FORMAT: 'Quality and format',
    RELEASE_LABEL: 'Release labels',
    BODY_PERSONA: 'Appearance and persona',
    ROLE_COSTUME: 'Roles and costumes',
    RELATION_CAST: 'Relationships and cast',
    GENRE_SCENARIO: 'Genres and settings',
    PLAY_FETISH: 'Themes and preferences',
    OTHER: 'Other',
  },
  library: {
    title: 'Library',
    favorites: 'Saved videos · {count}',
    favoritesTab: 'Saved videos',
    subscriptions: 'Followed actresses · {count}',
    favoritedAt: '{actress}',
    latest: 'Latest: {code}',
    quota: 'Free plan limits',
    emptyFavorites: 'No saved videos yet',
    emptyFavoritesBody: 'Tap the heart on any video card to save it.',
    emptySubs: 'You are not following any actresses yet',
  },
  search: {
    title: 'Search',
    placeholder: 'Search codes, actresses or tags',
    scopeAll: 'All',
    scopeVideos: 'Videos',
    scopeActresses: 'Actresses',
    scopeTags: 'Tags',
    exact: 'Exact code match',
    videos: 'Videos',
    actresses: 'Actresses',
    tags: 'Tags',
    open: '↵ Open',
    recent: 'Recent searches',
    clearRecent: 'Clear',
    noLocal: 'Not finding it locally? Search JavBus online.',
    onlineHint: 'Results are saved to the catalogue; cached results do not use your quota.',
    onlineButton: 'Search online for “{keyword}”',
    onlineQuota: '{remaining}/{limit} left today',
    onlineRunning: 'Searching online… {count, plural, one {# video} other {# videos}} found',
    onlineDone: 'Online search complete. {count, plural, one {# video} other {# videos}} found.',
    onlineCancel: 'Stop',
    onlineCancelled: 'Stopped receiving results. Videos already saved to the catalogue remain.',
    onlineExhausted: 'Your online search quota is used up for today',
    keyboardHints: '↑↓ Select · ↵ Open · Esc Close',
    typeToSearch: 'Enter at least 2 characters',
    searching: 'Searching…',
    noResult: 'No local matches',
    kindCode: 'Code',
    kindVideo: 'Video',
    kindActress: 'Actress',
    kindTag: 'Tag',
  },
  me: {
    defaultLanguage: 'Default language',
    defaultLanguageHint:
      'Used for new-release Telegram notifications and detail links. Defaults to Traditional Chinese. Interface language can be changed separately.',
    defaultLanguageSaved: 'Default language saved',

    title: 'Me',
    overview: 'Overview',
    membership: 'Membership and payment',
    telegram: 'Telegram notifications',
    cdkey: 'Redeem CDKey',
    security: 'Language and security',
    free: 'Free plan',
    active: 'Member',
    expired: 'Expired',
    lifetime: 'Lifetime member',
    until: 'Valid until {date}',
    verifyBanner:
      'Your email is not verified. Verify it before redeeming a CDKey, buying membership or linking Telegram.',
    resendVerify: 'Resend verification email',
    verifySent: 'Verification email queued. Please check your inbox shortly.',
    quotaSubs: 'Followed actresses',
    quotaOnline: 'Online searches · Today',
    quotaRefresh: 'Magnet refreshes · Today',
    perks:
      'Membership: unlimited follows and quotas, with no ads. Pay with cryptocurrency; benefits activate after payment is confirmed.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    lifetimePlan: 'Lifetime',
    perMonth: '/ month',
    perYear: '/ year',
    oneTime: 'One-time',
    bestValue: 'Best value',
    choose: 'Choose {plan}',
    price: '[Price]',
    orderPaid: 'Payment successful. Your membership is active.',
    orderCancelled: 'The order is closed. No membership was granted for this order.',
    orderUnknown:
      'The payment order is still unconfirmed. Check the original order instead of creating another.',
    goCheckout: 'Continue to payment',
    checkOrder: 'Check original order',
    tgUnknown:
      'The result is not yet confirmed. Check the link status; do not automatically repeat the request.',
    tgRegenerate: 'Getting a new code replaces the previous link code.',
    tgCopy: 'Copy link command',
    tgOpenBot: 'Open bot',
    tgCheck: 'Check link status',
    cdkeyConfirm: 'Confirm original redemption',
    cdkeyUnknown:
      'The redemption outcome is unknown. Membership status has been refreshed. Confirm the original request; do not submit a different code.',
    orderPending:
      'Order created. Waiting for payment confirmation. You may close this page; benefits are subject to server confirmation.',
    tgBound: 'Linked to @{username}',
    tgUnbound: 'Not linked',
    tgBody:
      'Get notifications when followed actresses release new videos. Receive 7 days of membership for your first link.',
    tgRewarded: 'First-link reward already claimed',
    tgTest: 'Send test message',
    tgTestSent: 'Test message queued',
    tgUnbind: 'Unlink',
    tgBind: 'Get link code',
    tgCode: 'Send this to the bot on Telegram: {code}',
    cdkeyLabel: 'Enter redemption code',
    cdkeyRedeem: 'Redeem',
    cdkeyNeedVerify: 'Verify your email to use this',
    cdkeyDone: 'Code redeemed. Membership is active.',
    cdkeyHint: 'Mock redemption code: DEMO-CDKEY-2026',
    language: 'Interface language',
    changePassword: 'Change password',
    logout: 'Sign out',
  },
  auth: {
    login: 'Sign in',
    register: 'Sign up',
    email: 'Email',
    password: 'Password',
    optional: 'Optional',
    forgot: 'Forgot password?',
    submitLogin: 'Sign in',
    submitRegister: 'Create account',
    demoLink: 'Explore the guest demo first →',
    passwordRule:
      'At least 8 characters, including letters and digits, and no more than 72 bytes (Chinese characters and emoji use multiple bytes)',
    headline: 'Follow actresses.\nGet new releases first.',
    mockHint: 'Mock account: demo@example.com or admin@example.com; password: password1',
    terms: 'Terms of service',
    privacy: 'Privacy policy',
    forgotTitle: 'Reset your password',
    forgotBody:
      'Enter your registered email. If Telegram is linked, the reset link goes there first; otherwise, it is sent by email.',
    forgotSubmit: 'Send reset link',
    forgotDoneTitle: 'Request submitted',
    forgotDone:
      'If the account is eligible, a reset link will be queued. This does not confirm delivery. You can request another in {seconds, plural, one {# second} other {# seconds}}.',
    forgotResend: 'Send again',
    forgotPrivacy:
      'The same response is shown for every email and does not reveal whether an account exists.',
    backToLogin: 'Back to sign in',
    forgotHeadline: 'Forgot your password?\nYour favorites are still here.',
    resetTitle: 'Set a new password',
    resetBody: 'All devices will be signed out when you finish.',
    newPassword: 'New password',
    confirmPassword: 'Enter it again',
    show: 'Show',
    hide: 'Hide',
    ruleLength: 'At least 8 characters (emoji may count as two)',
    ruleBytes: 'No more than 72 bytes (Chinese characters and emoji use multiple bytes)',
    ruleMix: 'Include letters and digits',
    ruleMatch: 'Passwords match',
    resetSubmit: 'Save new password',
    resetExpired: 'Link expired or already used?',
    resetAgain: 'Request another →',
    resetDone: 'Password updated. Please sign in again.',
    resetHeadline: 'Set a new key.\nOther devices will be signed out.',
    verifyingTitle: 'Verifying your email…',
    verifiedTitle: 'Email verified',
    verifiedBody:
      'You can now redeem CDKeys, buy membership and link Telegram for new-release notifications.',
    goBindTelegram: 'Link Telegram',
    backToday: 'Back to Today',
    verifyFailedTitle: 'Email verification incomplete',
    verifyFailedBody:
      'Check the error message. If the link has expired, sign in and request a new verification email.',
    registerEmailFailed:
      'Your account was created, but the verification email is not confirmed as queued. Request another from your account page.',
    alreadyVerified: 'Email already verified',
    currentPassword: 'Current password',
    logoutAll: 'Sign out all web sessions',
    logoutAllDone: 'Web sessions signed out. Please sign in again.',
    resendVerify: 'Resend verification email',
    goLogin: 'Sign in',
  },
  jobs: {
    nextPage: 'Search next page online',
    cancelling: 'Cancellation requested; waiting for confirmation',
    confirmRequest: 'Confirm original request',
    resume: 'Reconnect to task',
    unknown:
      'The submission is not yet confirmed. Confirming the original request uses the same request ID and will not duplicate an existing task.',
    disconnected:
      'The task may still be running. A disconnected connection does not cancel it. Reconnect to check its status.',
    partial: 'Some usable results are available. Quota usage is settled based on usable results.',
  },
  onboarding: {
    step1: 'Choose actresses',
    step2: 'Save videos',
    step3: 'Link Telegram',
    step4: 'Done',
    progress: '{current} / 1 · {label}',
    skip: 'Skip setup',
    title: 'Choose a few actresses to follow',
    body: 'We suggest 3; you can choose up to 5. Their new releases will appear in Today and can also be sent to Telegram.',
    selected: '{count} / 5 selected',
    continue: 'Follow {count} and continue',
    needOne: 'Choose at least 1',
  },
  landing: {
    navigation: 'Home navigation',
    eyebrow: 'YOUR PERSONAL RELEASE FEED',
    signupFree: 'Create free account',
    heroA: 'Follow your favorites.',
    heroB: 'Find what’s new.',
    heroBody:
      'Keep the actresses you follow, the releases you save and their updates together. Open JAV Tracker and start with what matters to you.',
    seePreview: 'See how it works',
    loginHint: 'Sign in to browse, follow and save. Registration availability is shown at sign-up.',
    previewTitle: 'Your subscription feed',
    example: 'Illustration',
    sampleOne: 'New releases from someone you follow',
    sampleTwo: 'A release worth saving for later',
    sampleAvailable: 'Magnet available',
    previewNote: 'Link Telegram to receive new-release notifications too.',
    exampleNote: 'Illustration only. Codes and content are synthetic examples, not live updates.',
    how: 'How it works',
    howTitle: 'Start following. Make it a habit.',
    f1Title: 'Find someone to follow',
    f1Body: 'Search names, codes or titles and explore releases and actress profiles.',
    f2Title: 'Build your own feed',
    f2Body:
      'Keep subscriptions together and browse releases by date. Save individual releases to your favorites.',
    f3Title: 'Check back, or get notified',
    f3Body: 'See subscription updates on your home page. Optionally link Telegram for notifications.',
    pricingTitle: 'Start free. Upgrade when you need to.',
    pricingBody:
      'A free account lets you browse, save releases and follow actresses. Subscription and online-action limits are shown in your account.',
    membershipBody:
      'Explore membership if you need more capacity. Current benefits, prices and purchase availability are shown after sign-in.',
    viewMembership: 'Sign in to view membership',
    startTitle: 'Start with someone you like.',
    startBody: 'Give yourself something to return for.',
    sessionError: 'We could not check your session. You can still read this page.',
    termsTitle: 'About the service',
    termsBody:
      'JAV Tracker is a catalogue and release-tracking tool for adults. Third-party information may be delayed or unavailable. Use the service only where permitted.',
    termsContact: 'Request full service terms ↗',
    privacyTitle: 'Privacy overview',
    privacyBody:
      'Cookies maintain your session. Subscriptions and favorites belong to your account. Linking Telegram is optional and can be reversed in your account. This is a feature summary; contact support for the full policy or data requests.',
    privacyContact: 'Privacy policy and data enquiries ↗',
    rights: '© JAV Tracker',
  },
  admin: {
    overview: 'Dashboard',
    users: 'Users',
    crawler: 'Crawler console',
    groupOverview: 'Overview',
    groupUsers: 'Users and revenue',
    groupContent: 'Content',
    groupCrawl: 'Crawling',
    groupSystem: 'System',
    revenue: 'Revenue',
    cdkeys: 'CDKeys',
    videos: 'Videos',
    aliases: 'Actress aliases',
    translations: 'Translation tasks',
    crawlerLogs: 'Crawler logs',
    config: 'System settings',
    monitor: 'Monitoring',
    notInScope: 'Not available in this release',
    backToApp: '← Back to app',
    refresh: 'Refresh',
    telegramTest: 'Send Telegram test',
    statVideos: 'Videos',
    statActresses: 'Actresses',
    statUsers: 'Users',
    statRevenue: 'Revenue this month',
    statTranslations: 'Awaiting translation',
    statQueue: 'Failed background tasks',
    delta24h: '+{count} in the last 24 hours',
    delta7d: '+{count} in the last 7 days',
    activeMembers: '{count, plural, one {# active member} other {# active members}}',
    sinceMonth: 'Since the start of the month, Beijing time',
    ingest: 'New catalogue entries · Last 14 days',
    sample: 'Mock data',
    deps: 'External dependencies',
    recentJobs: 'Recent background tasks',
    usersSub:
      '{count, plural, one {# user} other {# users}} · Administrators are exempt from email verification requirements',
    searchEmail: 'Search email',
    filterAll: 'All',
    filterActive: 'Active members',
    filterFree: 'Free',
    filterExpired: 'Expired',
    filterAdmin: 'Administrators',
    colEmail: 'Email',
    colRole: 'Role',
    colMembership: 'Membership',
    colTelegram: 'Telegram',
    colSubs: 'Follows',
    colCreated: 'Registered',
    roleAdmin: 'Administrator',
    roleUser: 'User',
    bound: 'Linked',
    unbound: 'Not linked',
    activate: 'Activate membership',
    activateTitle: 'Manually activate membership',
    current: 'Current: {status}',
    activateFooter: 'Recorded as revenue at the plan price and added to the audit log.',
    activateConfirm: 'Confirm activation',
    activateDone: 'Activated for {email}',
    pageOf: 'Page {page}',
    prev: 'Previous',
    next: 'Next',
    crawlerSub: 'Built-in scheduler queues every 3 hours · normal category only',
    startIncremental: 'Start site-wide incremental crawl',
    jobTitle: 'Release crawl · normal',
    running: 'Running',
    finished: 'This run is complete',
    stop: 'Request stop',
    slice: 'Current slice · Videos {processed} / {total}',
    sliceMeta: 'Pages {pages} / {pageLimit} · {elapsed}s / {budget}s',
    okCount: 'Succeeded this run',
    failCount: 'Failed',
    failHint: 'Will retry in the next slice',
    notifyCount: 'New-release notifications',
    notifyHint: 'Added to the notification queue',
    slots: 'Global concurrency slots',
    slotsHint: 'Shared across instances',
    crawlActress: 'Crawl one actress',
    starLabel: 'JavBus actress ID or name',
    enqueue: 'Add to queue',
    enqueueDone: 'Queued: {jobId}',
    enqueueHint: 'If a task already exists for this actress, it is returned without creating a duplicate.',
    liveLogs: 'Live logs',
    liveHint: 'Refreshes every 5 seconds',
    forbidden: 'Administrator access required',
  },
  membership: {
    FREE: 'Free',
    ACTIVE: 'Active',
    EXPIRED: 'Expired',
    MONTHLY: 'Monthly',
    YEARLY: 'Yearly',
    LIFETIME: 'Lifetime',
  },
} satisfies Messages
